import { AuthService } from '$services';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { listenForLargeScreen } from '../../../shared/utils';
import { NavComponent } from '../nav/nav.component';

@Component({
  selector: 'app-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [RouterLink, NavComponent, AsyncPipe],
})
export class HeaderComponent {
  private readonly auth = inject(AuthService);

  @Input() isHomePage: boolean | null = false;
  public readonly loggedIn$ = this.auth.isLoggedIn$;
  public readonly listenForLargeScreen$ = listenForLargeScreen();
}
